import React, {useState} from 'react';
import './index.scss';

const Gallery = ({
  images,
  chosenPhoto,
  exit,
  showDownload = true,
  showThumbnails = true,
}) => {
  const [currentPhoto, setCurrentPhoto] = useState(
    chosenPhoto ? chosenPhoto : images[0],
  );

  const downloadImage = imageUrl => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.target = '_blank';
    link.download = 'downloaded_image.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const minimal = !showDownload && !showThumbnails;

  return (
    <div className='gallery'>
      <div
        className={`gallery__content${minimal ? ' gallery__content--minimal' : ''}`}
      >
        <div className='gallery__content-header'>
          <img src='/assets/icons/close.svg' alt='close' onClick={exit} />
        </div>
        <div className='gallery__content-main'>
          <img
            className='gallery__content-img'
            src={currentPhoto}
            alt='photo'
          />
          {showDownload && (
            <img
              src='/assets/icons/download-img.svg'
              alt='download'
              className='gallery__content-download'
              onClick={() => downloadImage(currentPhoto)}
            />
          )}
        </div>
        {showThumbnails && (
          <div className='gallery__content-list'>
            {images?.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={'photo'}
                className={`gallery__content-elem ${currentPhoto == image ? 'active' : ''}`}
                onClick={() => setCurrentPhoto(image)}
              />
            ))}
          </div>
        )}
      </div>
      <div className='gallery__bg' onClick={exit}></div>
    </div>
  );
};

export default Gallery;
